/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';

const TransfacilRedirect = (): any => {
  window.location.href = 'https://ord.ink/RodaPeEmail';
  return null;
};

export default TransfacilRedirect;
